import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout, HomePage, CalculatorPage, ResultPage, EmptyState } from './renewal/Website';
import LegalPage from './renewal/LegalPage';

export default function App() {
  return <BrowserRouter><Routes><Route element={<SiteLayout />}>
    {['', '/pt', '/de', '/es'].map(prefix => <React.Fragment key={prefix}>
      <Route path={prefix || '/'} element={<HomePage />} />
      <Route path={`${prefix}/calculator`} element={<CalculatorPage />} />
      <Route path={`${prefix}/calculator/relatorio`} element={<ResultPage />} />
      <Route path={`${prefix}/privacy`} element={<LegalPage type="privacy" />} />
      <Route path={`${prefix}/imprint`} element={<LegalPage type="imprint" />} />
    </React.Fragment>)}
    <Route path="/policy" element={<Navigate replace to="/privacy" />} />
    <Route path="/policypt" element={<Navigate replace to="/pt/privacy" />} />
    <Route path="/policyde" element={<Navigate replace to="/de/privacy" />} />
    <Route path="/policyes" element={<Navigate replace to="/es/privacy" />} />
    <Route path="/datenschutz" element={<Navigate replace to="/de/privacy" />} />
    <Route path="/impressum" element={<Navigate replace to="/de/imprint" />} />
    <Route path="*" element={<EmptyState />} />
  </Route></Routes></BrowserRouter>;
}
